import styled from "styled-components";

export const LinkBtn = styled.button`
  text-transform: none !important;
  color: var(--primary);
  :hover {
    color: var(--primary-hover);
  }
`;
